import { createSvgIcon } from '@material-ui/core/utils';

export const CommandMenu = createSvgIcon(
  <>
    <path d="M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="9" cy="9" r="1" fill="currentColor"/>
    <circle cx="15" cy="9" r="1" fill="currentColor"/>
    <circle cx="9" cy="15" r="1" fill="currentColor"/>
    <circle cx="15" cy="15" r="1" fill="currentColor"/>
    <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
  </>,
  'CommandMenu'
);